module.exports = __webpack_public_path__ + "static/media/democratic-republic-of-congo.cd4fdfa9.svg";